/**
 * Mercado Pago (ENA-1607): `initiate` responde `payment.nextAction = { type: 'REDIRECT', url }` y el
 * usuario completa el pago en el checkout de Mercado Pago. Solo se acepta una URL https de ese dominio.
 */
import type { InitiateResponse } from '../domain/models';

const MERCADOPAGO_HOST = /(^|\.)mercadopago\.com(\.[a-z]{2})?$/i;

export const extractMercadoPagoRedirectUrl = (response: InitiateResponse): string | undefined => {
  const nextAction = response.payment?.nextAction;
  if (nextAction?.type !== 'REDIRECT' || typeof nextAction.url !== 'string') {
    return undefined;
  }
  try {
    const url = new URL(nextAction.url);
    return url.protocol === 'https:' && MERCADOPAGO_HOST.test(url.hostname) ? url.toString() : undefined;
  } catch {
    return undefined;
  }
};
